import React from "react";

export const createSidebarIconRenderer = (
	Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
) => (className: string) => <Icon className={className} />;
